import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CarouselService, NgxSiemaSlideComponent } from './siema'
import { NgxSiemaContainerComponent } from './siema/components/container.component'
import { SharedPolymorpheusModule } from '@alliance/shared/polymorpheus'
@NgModule({
  imports: [CommonModule, SharedPolymorpheusModule],
  declarations: [NgxSiemaContainerComponent, NgxSiemaSlideComponent],
  providers: [CarouselService],
  exports: [NgxSiemaContainerComponent, NgxSiemaSlideComponent]
})
export class SharedCarouselGalleryModule {}
